import { MouseToolBase } from "./mouse-tool-base";
import { View } from "../view";

export default class PanTool extends MouseToolBase {

    handleDrag(view: View, mousePointMm: number[], diff: number[]): void {
        let vm = view.viewManager;
        vm.pan(view, diff[0], diff[1]);
    }
}